import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { Exercise } from '../exercises/Exercise';
import { Dashboard, SiteHeader } from './Dashboard';
import { Login } from './Login';
import { AuthConditionalRender } from '../auth/AuthConditionalRender';
import { authStatuses, permissionsStatuses } from '../util/constants';
// import { Course, CourseContent, CourseRedirect } from '../courses/Course';
import { Router } from '../components/Router';
import { PermissionsConditionalRender } from '../permissions/PermissionsConditionalRender';
import { ShowSiteLoading } from '../SiteLoadingIndicator';
import { Account, AccountSubscribe } from './Account';
import { AuthenticatedScreen } from '../auth/AuthenticatedScreen';
import { ExerciseListScreen } from '../screens/ExerciseListScreen';
import { ExerciseInfoScreen } from './catalog/ExerciseInfoScreen';
import { WeeklyChallenge } from './WeeklyChallenge';
import { Discord } from './Discord';
import { Downloads } from './Downloads';
import { DailyPractice } from './DailyPractice';
import { DailyComplete } from './DailyComplete';
import { GetApp } from '../resources/getApp/GetApp';
import { CourseOverview } from '../courses/CourseOverview';
import { CourseLesson } from '../courses/CourseLesson';

const ChordProgressionGenerator = lazy(() =>
   import('../resources/chordProgressionGenerator/ChordProgressionGenerator')
);

const CircleOfFifths = lazy(() =>
   import('../resources/circleOfFifths/CircleOfFifths')
);

const AppRouter = () => (
   <AuthConditionalRender deniedStatuses={[authStatuses.pending]}>
      <PermissionsConditionalRender
         deniedStatuses={[permissionsStatuses.pending]}
      >
         <SiteHeader />
         <Router>
            {/* <Route path="/weekly-challenge" element={<WeeklyChallenge />} /> */}
            <Route
               path="/daily-practice"
               element={
                  <>
                     <AuthConditionalRender
                        deniedStatuses={[authStatuses.authenticated]}
                     >
                        <Navigate to="/app/login" replace />
                     </AuthConditionalRender>
                     <AuthConditionalRender
                        allowedStatuses={[authStatuses.authenticated]}
                     >
                        <PermissionsConditionalRender
                           allowedStatuses={[permissionsStatuses.loaded]}
                        >
                           <DailyPractice />
                        </PermissionsConditionalRender>
                     </AuthConditionalRender>
                  </>
               }
            />
            <Route
               path="/daily-complete"
               element={
                  <>
                     <AuthConditionalRender
                        deniedStatuses={[authStatuses.authenticated]}
                     >
                        <Navigate to="/app/login" replace />
                     </AuthConditionalRender>
                     <AuthConditionalRender
                        allowedStatuses={[authStatuses.authenticated]}
                     >
                        <PermissionsConditionalRender
                           allowedStatuses={[permissionsStatuses.loaded]}
                        >
                           <DailyComplete />
                        </PermissionsConditionalRender>
                     </AuthConditionalRender>
                  </>
               }
            />

            <Route
               path="/exercise/:exerciseId"
               element={
                  <>
                     <AuthConditionalRender
                        deniedStatuses={[authStatuses.authenticated]}
                     >
                        <Navigate to="/app/login" replace />
                     </AuthConditionalRender>
                     <AuthConditionalRender
                        allowedStatuses={[authStatuses.authenticated]}
                     >
                        <PermissionsConditionalRender
                           allowedStatuses={[permissionsStatuses.loaded]}
                        >
                           <Exercise />
                        </PermissionsConditionalRender>
                     </AuthConditionalRender>
                  </>
               }
            >
               <Route path=":moduleId" element={null} />
            </Route>

            <Route
               path="/course/:courseId"
               element={
                  <>
                     <AuthConditionalRender
                        deniedStatuses={[authStatuses.authenticated]}
                     >
                        <Navigate to="/app/login" replace />
                     </AuthConditionalRender>
                     <AuthConditionalRender
                        allowedStatuses={[authStatuses.authenticated]}
                     >
                        <PermissionsConditionalRender
                           allowedStatuses={[permissionsStatuses.loaded]}
                        >
                           <CourseOverview />
                        </PermissionsConditionalRender>
                     </AuthConditionalRender>
                  </>
               }
            />

            <Route
               path="/course/:courseId/:lessonId"
               element={
                  <>
                     <AuthConditionalRender
                        deniedStatuses={[authStatuses.authenticated]}
                     >
                        <Navigate to="/app/login" replace />
                     </AuthConditionalRender>
                     <AuthConditionalRender
                        allowedStatuses={[authStatuses.authenticated]}
                     >
                        <PermissionsConditionalRender
                           allowedStatuses={[permissionsStatuses.loaded]}
                        >
                           <CourseLesson />
                        </PermissionsConditionalRender>
                     </AuthConditionalRender>
                  </>
               }
            />
            <Route
               path="/dashboard"
               element={
                  <>
                     <AuthConditionalRender
                        deniedStatuses={[authStatuses.authenticated]}
                     >
                        <Navigate to="/app/login" replace />
                     </AuthConditionalRender>
                     <AuthConditionalRender
                        allowedStatuses={[authStatuses.authenticated]}
                     >
                        <PermissionsConditionalRender
                           allowedStatuses={[permissionsStatuses.loaded]}
                        >
                           <Dashboard />
                        </PermissionsConditionalRender>
                     </AuthConditionalRender>
                  </>
               }
            />

            {/* <Route path="/account">
               <Route
                  path=""
                  element={
                     <AuthenticatedScreen>
                        <Account />
                     </AuthenticatedScreen>
                  }
               />
               <Route
                  path="subscribe"
                  element={
                     <AuthenticatedScreen>
                        <AccountSubscribe />
                     </AuthenticatedScreen>
                  }
               />
            </Route>
            <Route
               path="/discord"
               element={
                  <AuthenticatedScreen>
                     <Discord />
                  </AuthenticatedScreen>
               }
            /> */}
            {/* <Route path="/downloads" element={<Downloads />} /> */}

            <Route path="/login" element={<Login />} />

            <Route path="/resources">
               <Route
                  path="chord-progression-generator"
                  element={<ChordProgressionGenerator />}
               />

               <Route path="circle-of-fifths" element={<CircleOfFifths />} />
               <Route path="get-app" element={<GetApp />} />
            </Route>

            <Route
               path="/catalog/exercise"
               element={
                  <>
                     <AuthConditionalRender
                        deniedStatuses={[authStatuses.authenticated]}
                     >
                        <Navigate to="/app/login" replace />
                     </AuthConditionalRender>
                     <AuthConditionalRender
                        allowedStatuses={[authStatuses.authenticated]}
                     >
                        <PermissionsConditionalRender
                           allowedStatuses={[permissionsStatuses.loaded]}
                        >
                           <ExerciseListScreen
                              title="Ear Training Exercises"
                              description="These ear training exercises for producers and audio engineers will help you learn and practice mixing, mastering, sound design, and music theory!"
                              linkPrefix="/app/catalog/exercise"
                           />
                        </PermissionsConditionalRender>
                     </AuthConditionalRender>
                  </>
               }
            />

            <Route
               path="/catalog/exercise/:exerciseId"
               element={
                  <>
                     <AuthConditionalRender
                        deniedStatuses={[authStatuses.authenticated]}
                     >
                        <Navigate to="/app/login" replace />
                     </AuthConditionalRender>
                     <AuthConditionalRender
                        allowedStatuses={[authStatuses.authenticated]}
                     >
                        <PermissionsConditionalRender
                           allowedStatuses={[permissionsStatuses.loaded]}
                        >
                           <ExerciseInfoScreen />
                        </PermissionsConditionalRender>
                     </AuthConditionalRender>
                  </>
               }
            >
               <Route path=":moduleId" element={null} />
            </Route>
         </Router>
      </PermissionsConditionalRender>

      <PermissionsConditionalRender allowedStatuses={[authStatuses.pending]}>
         <ShowSiteLoading />
      </PermissionsConditionalRender>
   </AuthConditionalRender>
);

export { AppRouter };
